<table class="table dynamic-table">
  <thead class="{{ customHeaderCss }}">
    <tr>
      @for (header of headerList; track header) {
        <th scope="col" [class]="header.className" [align]="header.columnHeaderAlignment">{{ header.headingName }}</th>
      }
      @if (headerTemplateRef) {
        <ng-container [ngTemplateOutlet]="headerTemplateRef"> </ng-container>
      }
    </tr>
  </thead>
  <tbody class="table-group-divider {{ customBodyCss }}">
    @for (row of masterList; track row) {
      <tr [class]="row.CssClass">
        @for (header of headerList; track header) {
          <td [class]="header.className" [align]="header.columnBodyAlignment">
            <mobi-office-lib-dynamic-mat-columns [row]="row" [item]="header"></mobi-office-lib-dynamic-mat-columns>
          </td>
        }
        @if (bodyTemplateRef) {
          <ng-container [ngTemplateOutlet]="bodyTemplateRef" [ngTemplateOutletContext]="{ $implicit: row }"> </ng-container>
        }
      </tr>
    }
  </tbody>
</table>
